import { useTranslation } from 'react-i18next';
import { useGetCatalogQuery } from '@platform/state/api';
import { useLabel } from '@platform/hooks/useLabel';
import { cx } from '@platform/core/lib/cx';
import type { IRecordsTableProps } from './IRecordsTableProps';
import { RecordRow } from './RecordRow';

/**
 * Таблиця записів «Нещодавні» / «Обране» (прототип v4 G:L2633–2687): картка радіус 12 з горизонтальною прокруткою, шапка 11px 600 великими
 * літерами на --surface2 (ID · Назва · Модуль · Статус · Виконавець · Оновлено), рядки 9px 14px; порожньо — одне речення.
 */
export function RecordsTable({ ws, items, empty, onRemove }: IRecordsTableProps) {
  const { t } = useTranslation();
  const label = useLabel();
  const { data: catalog } = useGetCatalogQuery({ workspaceId: ws });
  const head = ['colId', 'colTitle', 'colModule', 'colStatus', 'colAssignee', 'colUpdated'];
  return (
    <div className="rp-card">
      <div role="table" aria-label={t('recordsPages.table')} className={cx('rp-table', onRemove && 'has-star')}>
        <div role="row" className="rp-row rp-head">
          {head.map((k) => <span key={k} role="columnheader" className={k === 'colUpdated' ? 'rp-right' : undefined}>{t(`recordsPages.${k}`)}</span>)}
          {onRemove && <span role="columnheader" />}
        </div>
        {items?.map((i) => (
          <RecordRow key={i.recordId} item={i} onRemove={onRemove} moduleName={label(catalog?.modules.find((m) => m.key === i.module)?.name) || i.module} />
        ))}
        {items && !items.length && <div className="rp-empty">{empty}</div>}
      </div>
    </div>
  );
}
